import React from 'react';
import './ui.css';

export const SearchInput: React.FC<{
  value: string; onChange: (value: string) => void; placeholder?: string;
}> = ({ value, onChange, placeholder }) => (
  <input
    className="ui-search" type="search" value={value}
    onChange={(e) => onChange(e.target.value)} placeholder={placeholder}
  />
);
